module.exports = __webpack_public_path__ + "img/slide-5.ddac8589.png";